import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { FormFieldRequirementsSettings } from "../components/form-field-requirements/FormFieldRequirementsSettings.tsx"

export default function SettingsFormFieldRequirementsPage() {
  useEffect(() => {
    generateDocumentTitle("Settings Required Information")
  }, [])

  return <FormFieldRequirementsSettings />
}
